import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";
import {gsap} from "gsap";
import {BenjiKIVSymbol} from "../../reels/BenjiKIVSymbol";

/**
 * Created by Jerker Nord on 2022-11-28.
 */

export class BenjiKIVRespinWinRunner implements SimplePresentation {

    private _mainTL:gsap.core.Timeline;

    public shouldRun():boolean {
        return (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN);
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._mainTL = gsap.timeline({delay : 0, onComplete : () => {controller.finish()}});
        /*

        this._mainTL.add(gsap.timeline({delay : 1}));

         */
    }


}